import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../commonComponents/translate';
import GameProp from '../../propTypes/gameProp';
import RewardJourneyCard from '../../../journey/overall/content/components/RewardJourneyCard';

export function RewardContainer(props) {
  const { rewards, title, subtitle, hint } = props;
  const {
    coins,
    userType,
    isTrainer,
    isOperator,
    chatGroup,
    userSkillLevel,
    couponDiscount,
    coupon,
    userLevel,
  } = rewards || {};

  return (
    <div className="card-info normalRewards">
      <h6 className="award-title">{title}</h6>
      {subtitle && (
        <div className="subtitleWrapper">
          <h6 className="subtitle">{subtitle}</h6>
          {hint && <span className="hint-message">{hint}</span>}
        </div>
      )}
      <div className="rewardsContainer">
        {coins && <RewardJourneyCard type="coins" reward={rewards} />}
        {(userSkillLevel || userLevel) && (
          <RewardJourneyCard type="userLevel" reward={rewards} />
        )}
        {userType && <RewardJourneyCard type="userType" reward={rewards} />}
        {chatGroup && <RewardJourneyCard type="chatGroup" reward={rewards} />}
        {couponDiscount && (
          <RewardJourneyCard type="couponDiscount" reward={rewards} />
        )}
        {coupon && <RewardJourneyCard type="coupon" reward={rewards} />}
        {isTrainer && <RewardJourneyCard type="isTrainer" reward={rewards} />}
        {isOperator && <RewardJourneyCard type="isOperator" reward={rewards} />}
      </div>
    </div>
  );
}

RewardContainer.propTypes = {
  title: PropTypes.string.isRequired,
  rewards: PropTypes.shape({
    coins: PropTypes.number,
    userLevel: PropTypes.string,
    userType: PropTypes.shape({}),
    isTrainer: PropTypes.bool,
    isOperator: PropTypes.bool,
  }).isRequired,
  chatGroup: PropTypes.shape({}),
  subtitle: PropTypes.string,
  hint: PropTypes.string,
};

RewardContainer.defaultProps = {
  chatGroup: null,
  subtitle: null,
  hint: null,
};

function InfoContent(props) {
  const { t, challenge } = props;
  const {
    challenges = {},
    startDate: challengeStartDate,
    endDate: challengeEndDate,
    rewardChatGroup,
    chatGroup,
    rewardUserType,
    rewardCoins,
    rewardUserSkillLevel,
    rewardsExtras,
    boostReward,
    boostOverLoadScore,
    coupon,
  } = challenge || {};
  const { scoreTarget } = challenges || {};

  // Creating rewards object
  const rewards = {
    chatGroup: rewardChatGroup && chatGroup ? chatGroup : null,
    userType: rewardUserType || null,
    coins: rewardCoins?.winner || null,
    userLevel: rewardUserSkillLevel || null,
    isTrainer: rewardsExtras?.isTrainer,
    isOperator: rewardsExtras?.isOperator,
    couponDiscount: rewardsExtras?.couponDiscount,
    coupon,
  };

  console.log('*REWARDS', rewards);

  const hasBoostedRewards = boostOverLoadScore && boostReward;

  const startDate = moment(challengeStartDate).format('DD MMM, YYYY');
  const endDate = moment(challengeEndDate).format('DD MMM, YYYY');

  const subtitleBoostReward = `${t(
    'challengeDetails.about.boostOverloadScore',
  )}: ${boostOverLoadScore}`;
  const hintBoostReward = t('challengeDetails.about.boostOverloadScore.hint');

  return (
    <div className="rewards">
      <div className="card-info information">
        {scoreTarget && (
          <div className="scoreTargetWrapper">
            <img src="/images/target.svg" alt="target" />
            <div className="scoreTargetInfo">
              <span className="title">{t('challengeDetails_scoreTarget')}</span>
              <span className="value">{scoreTarget}</span>
            </div>
          </div>
        )}
        <div className="dateWrapper">
          <img src="/images/calendar.svg" alt="calendar" />
          <div className="dateInfo">
            <span className="title">{t('from')}</span>
            <span className="value">{startDate}</span>
            <span className="title">{t('to')}</span>
            <span className="value">{endDate}</span>
          </div>
        </div>
      </div>
      <RewardContainer
        t={t}
        rewards={rewards}
        chatGroup={chatGroup}
        title={t('awards')}
      />
      {hasBoostedRewards && (
        <RewardContainer
          t={t}
          rewards={boostReward}
          title={t('boost.rewards')}
          subtitle={subtitleBoostReward}
          hint={hintBoostReward}
        />
      )}
    </div>
  );
}

InfoContent.propTypes = {
  t: PropTypes.func.isRequired,
  challenge: PropTypes.shape(GameProp.propType).isRequired,
};

export default translate(InfoContent);
